import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Info } from 'lucide-react';

interface PaymentTabProps {
  config: Record<string, unknown>;
  setConfig: (config: Record<string, unknown>) => void;
}

export const PaymentTab: React.FC<PaymentTabProps> = ({
  config,
  setConfig,
}) => {
  const updateConfig = (key: string, value: unknown) => {
    setConfig({ ...config, [key]: value });
  };

  return (
    <div className="space-y-6">
      <div className="flex items-start gap-2 p-3 bg-muted/50 rounded-lg">
        <Info className="h-5 w-5 text-primary mt-0.5 shrink-0" />
        <p className="text-sm text-muted-foreground">
          This section is optional and can be configured later.
        </p>
      </div>

      <Card className="border-dashed">
        <CardContent className="pt-4 space-y-4">
          <div className="space-y-2">
            <Label className="text-sm">Payment Terms:</Label>
            <Select
              value={(config.payment_terms as string) || 'net30'}
              onValueChange={(value) => updateConfig('payment_terms', value)}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select payment terms" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="net15">Net 15</SelectItem>
                <SelectItem value="net30">Net 30</SelectItem>
                <SelectItem value="net45">Net 45</SelectItem>
                <SelectItem value="net60">Net 60</SelectItem>
                <SelectItem value="due_on_receipt">Due on Receipt</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label className="text-sm">Payment Method:</Label>
            <Select
              value={(config.payment_method as string) || 'ach'}
              onValueChange={(value) => updateConfig('payment_method', value)}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select payment method" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="ach">ACH Transfer</SelectItem>
                <SelectItem value="check">Check</SelectItem>
                <SelectItem value="wire">Wire Transfer</SelectItem>
                <SelectItem value="credit_card">Credit Card</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label className="text-sm">Bank Account (last 4 digits):</Label>
            <Input
              placeholder="e.g., ****1234"
              value={(config.bank_account as string) || ''}
              onChange={(e) => updateConfig('bank_account', e.target.value)}
              maxLength={8}
            />
          </div>

          <div className="flex items-center space-x-2">
            <Checkbox
              id="auto_pay"
              checked={(config.auto_pay as boolean) || false}
              onCheckedChange={(checked) => updateConfig('auto_pay', !!checked)}
            />
            <Label htmlFor="auto_pay" className="text-sm font-normal">
              Enable auto-pay for this account
            </Label>
          </div>
        </CardContent>
      </Card>

    </div>
  );
};
